import { addScrollEvent } from './scroll-event'

export const scrollTopButton = (btn: Element) => {
    addScrollEvent({
        position: 300,
        onEnter: () => {
            btn.classList.add('cd-is-visible')
            btn.classList.remove('cd-fade-out')
        },
        onLeave: () => {
            btn.classList.remove('cd-is-visible')
        },
    })

    addScrollEvent({
        position: 1200,
        onEnter: () => {
            btn.classList.add('cd-fade-out')
        },
    })
}
